import 'style-loader!./slide5.component.scss';
import { Component, OnInit, ViewEncapsulation, Output, Input, EventEmitter } from '@angular/core';
import { UserService } from 'app/theme/services/user.service';
import { User, Task } from 'app/theme/models/user.model';
import { LanguageService } from 'app/theme/services/language.service';
import { ChannelService } from 'app/theme/services/channel.service';
import { ElementRef, ViewChild } from '@angular/core';


@Component({
    selector: 'reg-slide5',
    templateUrl: './slide5.component.html',
    encapsulation: ViewEncapsulation.None

})
export class ClubComponent implements OnInit {
    stakeholder: string;
    email: string;
    phone: any;
    canale: string;
    Labels: any
    alerts: any
    task: Task;
    constructor(
        protected _userService: UserService,
        protected _translateService: LanguageService,
        protected _channelService: ChannelService,
    ) { }

    //CR ACCESSIBILITà
    @ViewChild('mainContent') mainContent: ElementRef | null = null;
    skipToMain(event: Event) {
        event.preventDefault(); // Evita il comportamento predefinito del link
        
        if (this.mainContent) {
          setTimeout(() => {
            this.mainContent.nativeElement.focus();
          }, 0); // Timeout per garantire che Angular abbia reso l'elemento visibile
        }
      }
    //
    ngOnInit() {
        this._userService.getUser()
            .subscribe((user: User) => {
                this.canale = user.info.canale;
                this.email = user.contacts.email;
                this.phone = user.contacts.cellulare;
                this.stakeholder = user.info.nome + " " + user.info.cognome;

            })
        this._translateService.translatePageIndex(9)
            .subscribe((Labels) => {
                if (Labels)
                    this.Labels = Labels;
            })
        this._channelService.getTask()
            .subscribe((task: Task) => {
                if (task)
                    this.task = task;
             })
    }

}


// WEBPACK FOOTER //
// ./src/app/theme/components/slide5/slide5.component.ts